export * from './sortCustomFormulas';

export const CUSTOM_FORMULA_TYPES = {
  hubspotEmail: 'hubspotEmail',
  email: 'email',
  facebookAd: 'facebookAd',
  facebookPost: 'facebookPost',
  linkedinAd: 'linkedinAd',
  linkedinPost: 'linkedinPost',
  twitterAd: 'twitterAd',
  twitterPost: 'twitterPost',
  googleAd: 'googleAd',
  instagram: 'instagram',
  landingPage: 'landingPage',
  youtubeVideo: 'youtubeVideo',
  outbrainAd: 'outbrainAd',
  taboolaAd: 'taboolaAd',
  pinterestAd: 'pinterestAd',
  pinterestPin: 'pinterestPin',
  amazon: 'amazon',
  wolmart: 'wolmart',
  generalListing: 'generalListing',
  seo: 'seo',
};
